import { Globe } from 'lucide-react';
import { lazy } from 'react';

import { customDomainsTranslations as enCustomDomains } from '@/lang/en/customDomains';
import { customDomainsTranslations as esCustomDomains } from '@/lang/es/customDomains';
import { customDomainsTranslations as ptCustomDomains } from '@/lang/pt/customDomains';
import { label, type FeatureModule } from '@/platform/app/contracts';
import { namespaceBundle } from '@/platform/i18n/types';

const CustomDomainsSection = lazy(() =>
  import('./presentation/components/CustomDomainsSection').then((m) => ({
    default: m.CustomDomainsSection,
  })),
);

/** The organization's own dashboard, API and email domains (settings section). */
export const customDomainsModule: FeatureModule = {
  id: 'custom-domains',
  settingsSections: [
    {
      id: 'customDomains',
      group: 'organization',
      order: 40,
      label: label('settings', 'nav_custom_domains'),
      icon: Globe,
      Component: CustomDomainsSection,
    },
  ],
  i18n: namespaceBundle('customDomains', {
    es: esCustomDomains,
    en: enCustomDomains,
    pt: ptCustomDomains,
  }),
};
